/* eslint-disable camelcase */
import React, { FC, useCallback, useMemo } from "react"
import moment from "moment"
import { Appearance } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { SimulationForm, ModelCreateScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { navigate } from "../../../../navigators"
import { delay } from "../../../../utils/delay"

export const SimulationCreateScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function SimulationCreateScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    simulationStore,
    simulationStore: modelStore,
    simulationStore: { simulation },
  } = useStores()

  const initialValues = useMemo<any>(() => {
    const isEdit = params && params === 'isEdit'
    const data = isEdit ? simulation : {};
    return {
      ...data,
      date: data.date && moment.utc(data.date).format("YYYY-MM-DD"),
      seed: data.seed,
      area: data.wide,
      periode: data.periode,
      biomass: data.biomass,
      survival: data.survival,
      size: data.size,
      feed: data.feed,
      currency: 'IDR',
      plan: data.plan,
    }
  }, [params, simulation])
  
  const onSubmit = useCallback(async (data: any) => {
    const params = {
      ...data,
      plan: data.plan.filter((p) => p.age && p.percent)
    }
    simulationStore.set("simulation", params)
    await delay(1)
    navigate("Home.Stack", "Home.Simulation.Stack")
  }, [simulationStore])

  return (
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={SimulationForm}
      initialValues={initialValues}
      modelStore={modelStore}
      onSubmit={onSubmit}
      ignoreDirty
      hideOnBlurred={false}
      doubleButton
      rightTx="simulationScreen.show"
    />
  )
})
